import { createSelector } from 'reselect';
import { get } from 'stash/utils';
import { baseSelector } from './entities';

export const advisoryESignatureSelector = createSelector(baseSelector, (state) =>
	get(state, 'advisory_agreements', {})
);

export const advisoryESignatureSelectorV2 = createSelector(baseSelector, (state) =>
	get(state, 'advisory_agreements_v2', {})
);

export const hasAdvisoryEsigSelector = createSelector(
	baseSelector,
	(state) => !!state.advisory_agreements?.advisoryEsigData?.signature?.esignedAt
);

export const SecondESignatureSelector = createSelector(baseSelector, (state) =>
	get(state, 'agreements', {})
);

export const AccountAgreementsSelector = createSelector(baseSelector, (state) =>
	get(state, 'accountAgreements', {})
);

export const AdvisoryDisclosureStatementSelector = createSelector(
	advisoryESignatureSelector,
	(state) => get(state, 'disclosureStatement', {})
);

export const AdvisoryCoreDisclosureStatementSelector = createSelector(
	advisoryESignatureSelector,
	(state) => get(state, 'coreDisclosureStatement', {})
);

export const AdvisoryDisclosureStatementSelectorV2 = createSelector(
	advisoryESignatureSelectorV2,
	(state) => get(state, 'disclosureStatement', {})
);

export const AdvisoryCoreDisclosureStatementSelectorV2 = createSelector(
	advisoryESignatureSelectorV2,
	(state) => get(state, 'coreDisclosureStatement', {})
);
